import Button from "./Button";
import Arrow from "./Arrow";


function ButtonNext(props){
    const href = props.href;
    return (
        <a href={href}>
                <Button>
                    <Arrow/>
                </Button>
            </a>
    )
}

export default ButtonNext;